var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"","show-file-list":false,"http-request":_vm.uploadLicense,"on-error":_vm.error,"on-success":_vm.success}},[_c('div',{staticClass:"up"},[(_vm.license)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.license}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }